import type { RefAttributes } from "react";
import type { PaymentPeriod, Quote } from "../../../../types";
import { PaymentInformation as Control } from "./PaymentInformation";

export type PaymentInformationProps = {
  quote: Quote;
  paymentPeriod?: PaymentPeriod;
};

export const PaymentInformation = ({
  ref,
  ...props
}: PaymentInformationProps & RefAttributes<HTMLDivElement>) => {
  return <Control {...props} ref={ref} />;
};

PaymentInformation.displayName = "PaymentInformation";
